/* eslint-disable camelcase */
import React from 'react';
import { toast } from 'react-toastify';
import { baseApi } from './base.service';
import { BASE } from './__fixtures__/service-fixtures';
import ToastAction from '../components/info-elements/toast-action';
import {
  BatchRequestOption,
  BatchPostResponse,
  BatchFetchResponse,
  LocalResponse,
  BatchPostMutation,
  BatchStorage,
} from '../models/batch';
import * as actions from '../global-nav/batch-menu.slice';
import batchToastMessages, { ToastMessageType } from './batch-toast-messages';

export type BatchData = {
  status?: string|null;
  project_id?: string|null;
  assigned_to_id?: string|null;
}

export const batchApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getBatches: build.query<LocalResponse, BatchRequestOption>({
      query: () => '/api/_private/batch?per_page=50&sort=\'ASC\'',
      transformResponse: (response: LocalResponse) => {
        const { batches } = response as BatchFetchResponse;

        if (!batches.length) {
          return undefined;
        }

        return response;
      },
      providesTags: [{ type: 'Batch', id: 'GET' }],
    }),
    postBatch: build.mutation<BatchPostResponse, BatchPostMutation & BatchStorage>({
      query({ start, operations }) {
        return {
          url: `${BASE}batch`,
          method: 'POST',
          body: { batch: { start, operations } },
        };
      },
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const { operations } = arg;
        const { action, data: operationData = {} } = operations[0];
        const data: BatchData = operationData as BatchData;
        const activityCenterButton = document.body.querySelector("button[data-testid='activity-center-button']");

        const pendingMessage = batchToastMessages(ToastMessageType.Pending, action, data);
        const successMessage = batchToastMessages(ToastMessageType.Success, action, data);

        toast.promise(queryFulfilled, {
          pending: {
            render() {
              return (
                <ToastAction
                  message={pendingMessage}
                  callback={() => {}}
                  text=""
                />
              );
            },
          },
          success: {
            icon: false,
            render() {
              return (
                <ToastAction
                  message={successMessage}
                  callback={() => dispatch(actions.setOpenBatchProcess(activityCenterButton))}
                  text="View Progress"
                />
              );
            },
          },
          error: {
            render() {
              return (
                <ToastAction
                  message={`There was a problem with the ${operations[0].action} request`}
                  callback={() => dispatch(actions.setOpenBatchProcess(activityCenterButton))}
                  text="View Error"
                />
              );
            },
          },
        });
      },
      invalidatesTags: [{ type: 'Batch', id: 'GET' }],
    }),
  }),
});

export const { useGetBatchesQuery, usePostBatchMutation } = batchApi;
